"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.type14Fields = void 0;
exports.type14Fields = {
    LogicalRecordLengthT14: {
        label: 'Logical Record Length',
        minLength: 3,
        maxLength: 7,
        required: false,
        desc: 'This mandatory ASCII field shall contain the total  count of the number of bytes in the Type-14 logical record. Field 14.001 shall specify the length  of the record, including every character of every field contained in the record, and the  information separators.',
        EBTS: {
            mnemonic: 'T14_LEN',
            index: '14.001',
            dataType: 'N'
        }
    },
    ImageDesignationCharacterT14: {
        label: 'Image Designation Character',
        minLength: 1,
        maxLength: 4,
        required: false,
        desc: 'This mandatory ASCII field shall be used to  identify the tenprint-fingerprint image contained in the record. This IDC shall match the IDC  found in the file content (CNT) field of the Type-1 record.',
        EBTS: {
            mnemonic: 'T14_IDC',
            index: '14.002',
            dataType: 'N'
        }
    },
    ImpressionTypeT14: {
        label: 'Impression Type',
        minLength: 1,
        maxLength: 2,
        required: false,
        options: [
            ['0', 'Live-scan Plain'],
            ['1', 'Live-Scan Rolled'],
            ['2', 'Nonlive-scan Plain'],
            ['3', 'Nonlive-scan Rolled'],
            ['4', 'Latent Impression'],
            ['5', 'Latent Tracing'],
            ['6', 'Latent Photo'],
            ['7', 'Latent Lift'],
            ['8', 'Live-scan vertical swipe'],
            ['10', 'Live-scan palm'],
            ['11', 'Nonlive-scan palm'],
            ['12', 'Latent palm impression'],
            ['13', 'Latent palm tracing'],
            ['14', 'Latent palm photo'],
            ['15', 'Latent palm lift'],
            ['20', 'Live-scan optical contact plain'],
            ['21', 'Live-scan optical contact rolled'],
            ['22', 'Live-scan non-optical contact plain'],
            ['23', 'Live-scan non-optical contact rolled'],
            ['24', 'Live-scan optical contactless plain'],
            ['25', 'Live-scan optical contactless rolled'],
            ['26', 'Live-scan non-optical contactless plain'],
            ['27', 'Live-scan non-optical contactless rolled'],
            ['28', 'Other'],
            ['29', 'Unknown']
        ],
        desc: 'This mandatory one- or two-byte ASCII field shall indicate  the manner by which the tenprint image information was obtained. The appropriate code (0-29)  selected from Table 11 of the ANSI/NIST-ITL 1-2007 standard shall be entered in this field.',
        EBTS: {
            mnemonic: 'T14_IMP',
            index: '14.003',
            dataType: 'N'
        }
    },
    SourceAgencyORIT14: {
        label: 'Source Agency / ORI',
        minLength: 9,
        maxLength: 20,
        required: false,
        desc: 'This mandatory ASCII field shall contain the identification of  the administration or organization that originally captured the tenprint image contained in the  record. Normally, the ORI of the agency that captured the image will be contained in this field.  The SRC may contain up to 43 identifying characters. The data content of this field shall be  defined by the user and be in accordance with the receiving agency.',
        EBTS: {
            mnemonic: 'T14_SRC',
            index: '14.004',
            dataType: 'AN'
        }
    },
    TenprintCaptureDate: {
        label: 'Tenprint Capture Date',
        type: 'date',
        maxLength: undefined,
        required: false,
        desc: 'This mandatory ASCII field shall contain the date that  the tenprint image was captured. The date shall appear as eight digits in the format  YYYYMMDD. The YYYY characters shall represent the year the image was captured; the MM  characters shall be the tens and units values of the month; and the DD characters shall be the tens  and units values of the day in the month. For example, the entry 20000229 represents February  29, 2000. The complete date must be a legitimate date.',
        EBTS: {
            mnemonic: 'T14_TCD',
            index: '14.005',
            dataType: 'N',
            format: 'YYYYMMDD'
        }
    },
    HorizontalLineLengthT14: {
        label: 'Horizontal Line Length',
        minLength: 3,
        maxLength: 4,
        required: false,
        desc: 'This mandatory ASCII field shall contain the number  of pixels contained on a single horizontal line of the transmitted image.',
        EBTS: {
            mnemonic: 'T14_HLL',
            index: '14.006',
            dataType: 'N'
        }
    },
    VerticalLineLengthT14: {
        label: 'Vertical Line Length',
        minLength: 3,
        maxLength: 4,
        required: false,
        desc: 'This mandatory ASCII field shall contain the number of  horizontal lines contained in the transmitted image.',
        EBTS: {
            mnemonic: 'T14_VLL',
            index: '14.007',
            dataType: 'N'
        }
    },
    ScaleUnitsT14: {
        label: 'Scale Units',
        minLength: 1,
        maxLength: 1,
        required: false,
        options: [
            ['0', 'No Scale Given'],
            ['1', 'Pixels per Inch'],
            ['2', 'Pixels per Centimeter']
        ],
        desc: "This mandatory ASCII field shall specify the units used to describe  the image sampling frequency (pixel density). A '1' in this field indicates pixels per inch; a '2'  indicates pixels per centimeter. A '0' in this field indicates no scale is given. For this case, the  quotient of HPS/VPS gives the pixel aspect ratio.",
        EBTS: {
            mnemonic: 'T14_SLC',
            index: '14.008',
            dataType: 'N'
        }
    },
    HorizontalPixelScaleT14: {
        label: 'Horizontal Pixel Scale',
        minLength: 1,
        maxLength: 4,
        required: false,
        desc: "This mandatory ASCII field shall specify the integer  pixel density used in the horizontal direction providing the SLC contains a '1' or a '2'.  Otherwise, it indicates the horizontal component of the pixel aspect ratio.",
        EBTS: {
            mnemonic: 'T14_HPS',
            index: '14.009',
            dataType: 'N'
        }
    },
    VerticalPixelScaleT14: {
        label: 'Vertical Pixel Scale',
        minLength: 1,
        maxLength: 4,
        required: false,
        desc: "This mandatory ASCII field shall specify the integer pixel density used in the vertical direction of  the transmitted image providing the SLC contains a '1' or a '2'. Otherwise, it indicates the  vertical component of the pixel aspect ratio.",
        EBTS: {
            mnemonic: 'T14_VPS',
            index: '14.010',
            dataType: 'N'
        }
    },
    CompressionAlgorithmT14: {
        label: 'Compression Algorithm',
        minLength: 3,
        maxLength: 5,
        required: false,
        options: [
            ['NONE', 'None'],
            ['WSQ', 'Wavelet Scalar Quantization (WSQ)'],
            ['WSQ20', 'Wavelet Scalar Quantization (WSQ) FBI Revision 2.0'],
            ['JPEGB', 'Baseline Compression'],
            ['JPEGL', 'Lossless Compression'],
            ['JP2', 'JPEG 2000 ISO/IEC 15444-1 (Lossy)'],
            ['JP2L', 'JPEG 2000 ISO/IEC 15444-1 (Lossless)'],
            ['PNG', 'Portable Network Graphics']
        ],
        desc: "This mandatory ASCII field shall specify the  algorithm used to compress grayscale images. An entry of 'NONE' in this field indicates that  the data contained in this record are uncompressed. For those images that are to be compressed,  this field shall contain 'WSQ20' the preferred method for the compression of tenprint  fingerprint images.",
        EBTS: {
            mnemonic: 'T14_CGA',
            index: '14.011',
            dataType: 'AN'
        }
    },
    BitsPerPixelT14: {
        label: 'Bits per pixel',
        minLength: 1,
        maxLength: 2,
        required: false,
        desc: 'This mandatory ASCII field shall contain the number of bits used  to represent a pixel. This field shall contain an entry of 8 for normal grayscale values of 0 to  255.',
        EBTS: {
            mnemonic: 'T14_BPX',
            index: '14.012',
            dataType: 'N'
        }
    },
    FingerPositionT14: {
        label: 'Finger Position',
        minLength: 1,
        maxLength: 2,
        maxOccurrences: 6,
        required: false,
        options: [
            ['0', 'Unknown Finger'],
            ['1', 'Right Thumb'],
            ['2', 'Right Index Finger'],
            ['3', 'Right Middle Finger'],
            ['4', 'Right Ring Finger'],
            ['5', 'Right Little Finger'],
            ['6', 'Left Thumb'],
            ['7', 'Left Index Finger'],
            ['8', 'Left Middle Finger'],
            ['9', 'Left Ring Finger'],
            ['10', 'Left Little Finger'],
            ['11', 'Plain Right Thumb'],
            ['12', 'Plain Left Thumb'],
            ['13', 'Plain Right Four Fingers'],
            ['14', 'Plain Left Four Fingers'],
            ['15', 'Left and Right Thumbs'],
            ['19', 'EJI or Tip']
        ],
        desc: 'This mandatory tagged field shall contain finger position code  that matches the tenprint image. The decimal code number corresponding to the known or most  probable finger position shall be taken from Table N-1 and entered as a one- or two-character  ASCII subfield. Table N-1 also lists the maximum image area that can be transmitted for each of  the 14 possible finger positions.',
        EBTS: {
            mnemonic: 'T14_FGP',
            index: '14.013',
            dataType: 'N'
        }
    },
    MajorCasePrint: {
        label: 'Major Case Print',
        type: 'header',
        minLength: 4,
        maxLength: 5,
        desc: "This optional tagged field shall be present when the finger  position code '19' appears in Field 14.013. This field shall consist of two mandatory  information items. The first is the probable decimal finger position code (0-10) taken from Table  12. A '0' indicates that all the fingers of a possible candidate should be searched. The second  information item is the code taken from Table 31 to indicate the portion of the major case print  fingerprint image that is stored as a single image in the database. There may be up to 17 such  images for a single finger. There may be up to four full-finger images in an entire joint image  (EJI). These are numbered 1 to 4 as they appear left to right in the EJI and correspond to the x in  FVx.",
        EBTS: {
            mnemonic: 'T14_MCP',
            index: '14.014:',
            dataType: 'AN'
        },
        subFields: {
            fields: {
                MajorCasePrintFingerprintPosition: {
                    label: 'Major Case Print Fingerprint Position',
                    minLength: 1,
                    maxLength: 2,
                    required: false,
                    options: [
                        ['0', 'Unknown Finger'],
                        ['1', 'Right Thumb'],
                        ['2', 'Right Index Finger'],
                        ['3', 'Right Middle Finger'],
                        ['4', 'Right Ring Finger'],
                        ['5', 'Right Little Finger'],
                        ['6', 'Left Thumb'],
                        ['7', 'Left Index Finger'],
                        ['8', 'Left Middle Finger'],
                        ['9', 'Left Ring Finger'],
                        ['10', 'Left Little Finger'],
                        ['11', 'Plain Right Thumb'],
                        ['12', 'Plain Left Thumb'],
                        ['13', 'Plain Right Four Fingers'],
                        ['14', 'Plain Left Four Fingers'],
                        ['15', 'Left and Right Thumbs'],
                        ['19', 'EJI or Tip']
                    ],
                    EBTS: {
                        mnemonic: 'T14_MCP_FGP',
                        index: '14.014..1',
                        dataType: 'N'
                    }
                },
                MajorCasePrintEJIAndTipCodes: {
                    label: 'Major Case Print EJI and Tip Codes',
                    minLength: 3,
                    maxLength: 3,
                    required: false,
                    options: [
                        ['EJI', 'Entire Joint Image'],
                        ['TIP', 'LRolled Tip TIP'],
                        ['FV1', 'Full Finger Rolled Image'],
                        ['FV2', 'Full Finger Plain Image – left side'],
                        ['FV3', 'Full Finger Plain Image – center'],
                        ['FV4', 'Full Finger Plain Image – right side'],
                        ['PRX', 'Proximal'],
                        ['DST', 'Distal'],
                        ['MED', 'Medial']
                    ],
                    EBTS: {
                        mnemonic: 'T14_MCP_ETC',
                        index: '14.014..2',
                        dataType: 'A'
                    }
                }
            }
        },
        required: false
    },
    MajorCasePrintSegmentPosition: {
        label: 'Major Case Print Segment Position',
        type: 'header',
        minLength: 9,
        maxLength: 18,
        maxOccurrences: 12,
        desc: "This optional ASCII field may contain  offsets to the locations for the bounding box of the EJI, each of the full-finger views, or segments  within the EJI. When used, this field shall consist of six mandatory information items to  describe the type or portion of the image and its location within an entire joint image. The first  information item is the number of the full-finger view with values of 'FV0' through 'FV4.' A  value of 'FV0' is used to specify the bounding coordinates for all of the combined full-finger  views within the EJI. Values of 'FV1' to 'FV4' specify the bounding coordinates for each full- finger view. The second information item is used to identify the location of a segment within a  full-finger view. It will contain the not applicable code 'NA' if the image portion refers to a  full-finger view or to the entire joint image locations. It shall contain 'PRX,' 'DST,' 'MED'  for a proximal, distal, or medial segment. The next four information items are the horizontal and  vertical offsets relative to the origin positioned in the upper left corner of the image. The  horizontal offsets (X) are the pixel counts to the right, and the vertical offsets (Y) are the pixel  counts down. The location of the image portion is defined by the sequence of X coordinates  (LEFT, RIGHT) and the Y coordinates (TOP, BOTTOM), of its bounding box. For the case of a  fingertip, the first information item shall be 'TIP,' and the second information item shall be  'NA.' The next four information items are the horizontal and vertical offsets as defined above.  The six information items within the field are separated by five US separators. This information  will describe either the location of the entire joint image, one full-finger view, or segment.  Individual full-finger or segment definitions may be repeated as subfields separated by the RS separator.",
        EBTS: {
            mnemonic: 'T14_MPS',
            index: '14.015:',
            dataType: 'AN'
        },
        subFields: {
            fields: {
                MajorCasePrintSegmentFingerValue: {
                    label: 'Major Case Print Segment Finger Value',
                    minLength: 3,
                    maxLength: 3,
                    required: false,
                    options: [
                        ['FV0', 'FV0'],
                        ['FV1', 'FV1'],
                        ['FV2', 'FV2'],
                        ['FV3', 'FV3'],
                        ['FV4', 'FV4']
                    ],
                    EBTS: {
                        mnemonic: 'T14_MPS_FVX',
                        index: '14.015..1',
                        dataType: 'AN'
                    }
                },
                MajorCasePrintSegmentLocation: {
                    label: 'Major Case Print Segment Location',
                    minLength: 2,
                    maxLength: 3,
                    required: false,
                    options: [
                        ['NA', 'Not Applicable'],
                        ['PRX', 'Proximal'],
                        ['DST', 'Distal'],
                        ['MED', 'Medial']
                    ],
                    EBTS: {
                        mnemonic: 'T14_MPS_LOC',
                        index: '14.015..2',
                        dataType: 'A'
                    }
                },
                MajorCasePrintSegmentPositionLeft: {
                    label: 'Major Case Print Segment Position Left',
                    minLength: 1,
                    maxLength: 4,
                    required: false,
                    EBTS: {
                        mnemonic: 'T14_MPS_LFT',
                        index: '14.015..3',
                        dataType: 'N'
                    }
                },
                MajorCasePrintSegmentPositionRight: {
                    label: 'Major Case Print Segment Position Right',
                    minLength: 1,
                    maxLength: 4,
                    required: false,
                    EBTS: {
                        mnemonic: 'T14_MPS_RGT',
                        index: '14.015..4',
                        dataType: 'N'
                    }
                },
                MajorCasePrintSegmentPositionTop: {
                    label: 'Major Case Print Segment Position Top',
                    minLength: 1,
                    maxLength: 4,
                    required: false,
                    EBTS: {
                        mnemonic: 'T14_MPS_TOP',
                        index: '14.015..5',
                        dataType: 'N'
                    }
                },
                MajorCasePrintSegmentPositionBottom: {
                    label: 'Major Case Print Segment Position Bottom',
                    minLength: 1,
                    maxLength: 4,
                    required: false,
                    EBTS: {
                        mnemonic: 'T14_MPS_BTM',
                        index: '14.015..6',
                        dataType: 'N'
                    }
                }
            }
        },
        required: false
    },
    ScanHorizontalPixelScaleT14: {
        label: 'Scan Horizontal Pixel Scale',
        minLength: 1,
        maxLength: 4,
        desc: "This optional ASCII field shall specify the horizontal pixel density used for the scanning of the  image providing the SLC field contains a '1' or a '2'. Otherwise, it indicates the horizontal  component of the pixel aspect ratio.",
        EBTS: {
            mnemonic: 'T14_SHPS',
            index: '14.016',
            dataType: 'N'
        },
        required: false
    },
    ScanVerticalPixelScaleT14: {
        label: 'Scan Vertical Pixel Scale',
        minLength: 1,
        maxLength: 4,
        desc: "This optional ASCII field shall specify the vertical pixel density used for the scanning of the image  providing the SLC field contains a '1' or a '2'. Otherwise, it indicates the vertical component of  the pixel aspect ratio.",
        EBTS: {
            mnemonic: 'T14_SVPS',
            index: '14.017',
            dataType: 'N'
        },
        required: false
    },
    AmputatedOrBandagedT14: {
        label: 'Amputated or Bandaged',
        type: 'header',
        minLength: 4,
        maxLength: 4,
        maxOccurrences: 4,
        desc: 'This optional ASCII field shall specify if one or more  fingers are amputated or bandaged. This field shall consist of one subfield for each amputated or  missing finger. Each subfield shall contain two information items separated by the US separator.  The first item is the finger number between one and ten as chosen from Table 12 in the ANSI- NIST-ITL 1-2007 Standard. The second item is the amputated or bandaged code (AMPCD).  This field is to be used  anytime there are fewer than expected printable fingers in a submission (e.g., less than four in a  left or right slap or less than two in the two-thumb slap). A partially scarred finger should be  printed.',
        EBTS: {
            mnemonic: 'T14_AMP',
            index: '14.018:',
            dataType: 'AN'
        },
        subFields: {
            fields: {
                FingerPosition: {
                    label: 'Finger Position',
                    minLength: 2,
                    maxLength: 2,
                    required: false,
                    options: [
                        ['01', 'Right Thumb'],
                        ['02', 'Right Index'],
                        ['03', 'Right Middle'],
                        ['04', 'Right Ring'],
                        ['05', 'Right Little'],
                        ['06', 'Left Thumb'],
                        ['07', 'Left Index'],
                        ['08', 'Left Middle'],
                        ['09', 'Left Ring'],
                        ['10', 'Left Little']
                    ],
                    EBTS: {
                        mnemonic: 'T14_AMP_FGP',
                        index: '14.018..1',
                        dataType: 'N'
                    }
                },
                AmputatedOrBandagedCode: {
                    label: 'Amputated or Bandaged Code',
                    minLength: 2,
                    maxLength: 2,
                    required: false,
                    options: [
                        ['XX', 'Amputation'],
                        ['UP', 'Unable to Print']
                    ],
                    EBTS: {
                        mnemonic: 'T14_AMP_AMPCD',
                        index: '14.014..2',
                        dataType: 'A'
                    }
                }
            }
        },
        required: false
    },
    CommentT14: {
        label: 'Comment',
        minLength: 1,
        maxLength: 127,
        desc: 'This optional field may be used to insert comments or other ASCII  text information with the tenprint image data.',
        EBTS: {
            mnemonic: 'T14_COM',
            index: '14.020',
            dataType: 'ANS',
            specialChars: 'PRINT'
        },
        required: false
    },
    SegmentPosition: {
        label: 'Segment Position',
        type: 'header',
        minLength: 5,
        maxLength: 18,
        desc: 'This mandatory ASCII field shall contain offsets to  the locations of image segments containing the individual fingers within the image. The offsets  are relative to the origin (0,0), which is in the upper left corner of the image. The horizontal  offsets (X) are the pixel counts to the right, and the vertical offsets (Y) are the pixel counts down.  A finger segment is defined by the FINGER NUMBER, the X coordinates (LEFT, RIGHT), and  the Y coordinates (TOP, BOTTOM) of its bounding box. The five information items within a  finger segment definition are separated by the US separator.',
        EBTS: {
            mnemonic: 'T14_SEG',
            index: '14.021:',
            dataType: 'N'
        },
        subFields: {
            fields: {
                SegmentPositionFingerNumber: {
                    label: 'Segment Position Finger Number',
                    minLength: 1,
                    maxLength: 2,
                    required: false,
                    EBTS: {
                        mnemonic: 'T14_SEG_FGN',
                        index: '14.021..1',
                        dataType: 'N'
                    }
                },
                SegmentPositionLeft: {
                    label: 'Segment Position Left',
                    minLength: 1,
                    maxLength: 4,
                    required: false,
                    EBTS: {
                        mnemonic: 'T14_SEG_LFT',
                        index: '14.021..2',
                        dataType: 'N'
                    }
                },
                SegmentPositionRight: {
                    label: 'Segment Position Right',
                    minLength: 1,
                    maxLength: 4,
                    required: false,
                    EBTS: {
                        mnemonic: 'T14_SEG_RGT',
                        index: '14.021..3',
                        dataType: 'N'
                    }
                },
                SegmentPositionTop: {
                    label: 'Segment Position Top',
                    minLength: 1,
                    maxLength: 4,
                    required: false,
                    EBTS: {
                        mnemonic: 'T14_SEG_TOP',
                        index: '14.021..4',
                        dataType: 'N'
                    }
                },
                SegmentPositionBottom: {
                    label: 'Segment Position Bottom',
                    minLength: 1,
                    maxLength: 4,
                    required: false,
                    EBTS: {
                        mnemonic: 'T14_SEG_BTM',
                        index: '14.021..5',
                        dataType: 'N'
                    }
                }
            }
        },
        required: false
    },
    NISTQualityMetric: {
        label: 'NIST Quality Metric',
        type: 'header',
        minLength: 2,
        maxLength: 4,
        minOccurrences: 2,
        maxOccurrences: 4,
        desc: 'This mandatory ASCII field shall contain the image  quality scores for the individual fingers. Each finger score is defined by the FINGER NUMBER  and the QUALITY SCORE separated by the US separator. Individual finger quality definitions are  separated by the RS separator. This field will be accepted for legacy users only. All new CJIS  users will be required to populate the Fingerprint Quality Metric field (14.024 FQM).',
        EBTS: {
            mnemonic: 'T14_NQM',
            index: '14.022:',
            dataType: 'N'
        },
        subFields: {
            fields: {
                ImageQualityMetricFingerNumber: {
                    label: 'Image Quality Metric Finger Number',
                    minLength: 1,
                    maxLength: 2,
                    required: false,
                    EBTS: {
                        mnemonic: 'T14_IQM_FGN',
                        index: '14.022..1',
                        dataType: 'N'
                    }
                },
                ImageQualityMetricQualityScore: {
                    label: 'Image Quality Metric Quality Score',
                    minLength: 1,
                    maxLength: 2,
                    required: false,
                    EBTS: {
                        mnemonic: 'T14_IQM_QSC',
                        index: '14.022..2',
                        dataType: 'N'
                    }
                }
            }
        },
        required: false
    },
    SegmentationQualityMetric: {
        label: 'Segmentation Quality Metric',
        type: 'header',
        minLength: 7,
        maxLength: 14,
        desc: "This optional ASCII field provides a measure of  estimated correctness regarding the accuracy of the location of the segmented finger within the  right or left four fingers or two thumbs slap image. For each segmented finger, this field shall  contain four information items separated by the US separator character. The first information item  is the finger number between one and ten as chosen from Table 12. The other three items  identify a quality score and the algorithm used to create the quality score. This information is  useful to enable the recipient of the quality score to differentiate between quality scores  generated by different algorithms and adjust for any differences in processing or analysis as  necessary.  The second information item shall be a measure of estimated correctness regarding the  accuracy of the location of the segmented finger. This item contains the ASCII representation of  the integer image quality score between 0 and 100 assigned to the image data by a quality  algorithm. Higher values indicate better quality. An entry of '255' shall indicate a failed  attempt to calculate a quality score. An entry of '254' shall indicate that no attempt to calculate  a quality score was made. The use of additional values to convey other information should be  harmonized with ISO/IEC 19794 standards.  The third information item shall specify the integer value that is the ID of the vendor of the  quality algorithm used to calculate the quality score. The IBIA shall maintain the Vendor  Registry of CBEFF Biometric Organizations that will map the value in this field to a registered  organization.  The fourth information item shall specify a numeric product code assigned by the vendor of  the quality algorithm, which may be registered with the IBIA, but registration is not required. It  indicates which of the vendor’s algorithms was used in the calculation of the quality score. This  field contains the ASCII representation of the integer product code and should be within the  range 1 to 65,535. This subfield is repeated for each segmented finger whose coordinates appear  in field 14.021.",
        EBTS: {
            mnemonic: 'T14_SQM',
            index: '14.023:',
            dataType: 'N'
        },
        subFields: {
            fields: {
                SegmentationQualityFingerprintNumber: {
                    label: 'Segmentation Quality Fingerprint Number',
                    minLength: 1,
                    maxLength: 2,
                    required: false,
                    options: [
                        ['1', 'Right Thumb'],
                        ['2', 'Right Index Finger'],
                        ['3', 'Right Middle Finger'],
                        ['4', 'Right Ring Finger'],
                        ['5', 'Right Little Finger'],
                        ['6', 'Left Thumb'],
                        ['7', 'Left Index Finger'],
                        ['8', 'Left Middle Finger'],
                        ['9', 'Left Ring Finger'],
                        ['10', 'Left Little Finger']
                    ],
                    EBTS: {
                        mnemonic: 'T14_SQM_FGN',
                        index: '14.023..1',
                        dataType: 'N'
                    }
                },
                SegmentationQualityScore: {
                    label: 'Segmentation Quality Score',
                    minLength: 1,
                    maxLength: 3,
                    required: false,
                    EBTS: {
                        mnemonic: 'T14_SQM_SCR',
                        index: '14.023..2',
                        dataType: 'N'
                    }
                },
                SegmentationQualityVendor: {
                    label: 'Segmentation Quality Vendor',
                    minLength: 4,
                    maxLength: 4,
                    required: false,
                    EBTS: {
                        mnemonic: 'T14_SQM_VEN',
                        index: '14.023..3',
                        dataType: 'AN'
                    }
                },
                SegmentationQualityProductCode: {
                    label: 'Segmentation Quality Product Code',
                    minLength: 1,
                    maxLength: 5,
                    required: false,
                    EBTS: {
                        mnemonic: 'T14_SQM_PROD',
                        index: '14.023..4',
                        dataType: 'N'
                    }
                }
            }
        },
        required: false
    },
    FingerprintQualityMetric: {
        label: 'Fingerprint Quality Metric',
        type: 'header',
        minLength: 7,
        maxLength: 14,
        desc: "This ASCII field is used to specify one  or more different metrics of fingerprint image quality score data for the image stored in this  record. The meaning attributed to this metric must be defined and interpreted by the producer of  the scoring algorithm or by the person or system used to assign the metric to the fingerprint  image. The metric may be a predictor of AFIS matcher accuracy performance or a different  metric to indicate a value associated with the quality of the fingerprint image for a particular  function.  This field may contain one or more subfields, each consisting of four information items  separated by the US separator character. The first information item is the finger number as chosen  from Table 12. The other three items identify a quality score and the algorithm used to create the  quality score. This information is useful to enable the recipient of the quality score to  differentiate between quality scores generated by different algorithms and adjust for any  differences in processing or analysis as necessary.  The second information item shall be a quantitative expression of the predicted matching  performance of the biometric sample. This item contains the ASCII representation of the integer  image quality score between 0 and 100 assigned to the image data by a quality algorithm.  Higher values indicate better quality. An entry of '255' shall indicate a failed attempt to  calculate a quality score. An entry of '254' shall indicate that no attempt to calculate a quality  score was made. The use of additional values to convey other information should be harmonized  with ISO/IEC 19794 standards.  The third information item shall specify the integer value that is the ID of the vendor of the  quality algorithm used to calculate the quality score. The IBIA shall maintain the Vendor  Registry, which will map the value in this field to a registered organization.  The fourth information item shall specify a numeric product code assigned by the vendor of  the quality algorithm, which may be registered with the IBIA, but registration is not required. It  indicates which of the vendor’s algorithms was used in the calculation of the quality score. This  field contains the ASCII representation of the integer product code and should be within the  range 1 to 65,535.",
        EBTS: {
            mnemonic: 'T14_FQM',
            index: '14.024:',
            dataType: 'N'
        },
        subFields: {
            fields: {
                AlternateFingerprintNumber: {
                    label: 'Alternate Fingerprint Number',
                    minLength: 1,
                    maxLength: 2,
                    required: false,
                    options: [
                        ['1', 'Right Thumb'],
                        ['2', 'Right Index Finger'],
                        ['3', 'Right Middle Finger'],
                        ['4', 'Right Ring Finger'],
                        ['5', 'Right Little Finger'],
                        ['6', 'Left Thumb'],
                        ['7', 'Left Index Finger'],
                        ['8', 'Left Middle Finger'],
                        ['9', 'Left Ring Finger'],
                        ['10', 'Left Little Finger']
                    ],
                    EBTS: {
                        mnemonic: 'T14_FQM_FGN',
                        index: '14.024..1',
                        dataType: 'N'
                    }
                },
                AlternateFingerprintQualityScore: {
                    label: 'Alternate Fingerprint Quality Score',
                    minLength: 1,
                    maxLength: 3,
                    required: false,
                    EBTS: {
                        mnemonic: 'T14_FQM_SCR',
                        index: '14.024..2',
                        dataType: 'N'
                    }
                },
                AlternateFingerprintQualityVendor: {
                    label: 'Alternate Fingerprint Quality Vendor',
                    minLength: 4,
                    maxLength: 4,
                    required: false,
                    EBTS: {
                        mnemonic: 'T14_FQM_VEN',
                        index: '14.024..3',
                        dataType: 'AN'
                    }
                },
                AlternateFingerprintQualityProductCode: {
                    label: 'Alternate Fingerprint Quality Product Code',
                    minLength: 1,
                    maxLength: 5,
                    required: false,
                    EBTS: {
                        mnemonic: 'T14_FQM_PRD',
                        index: '14.024..4',
                        dataType: 'N'
                    }
                }
            }
        },
        required: false
    },
    DeviceMonitoringModeT14: {
        label: 'Device Monitoring Mode',
        minLength: 7,
        maxLength: 10,
        options: [
            ['CONTROLLED', 'Operator physically controls the subject to acquire biometric sample'],
            ['ASSISTED', 'Person available to provide assistance to subject submitting the biometric'],
            ['OBSERVED', 'Person present to observe operation of the device but provides no assistance'],
            ['UNATTENDED', 'No one present to observe or provide assistance'],
            ['UNKNOWN', 'No information is known']
        ],
        desc: 'This optional field provides information describing  the level of human monitoring for the image capture device. This field will contain an entry  from Table 26 of ANSI/NIST-ITL 1-2007 to indicate the monitoring mode of the biometric  sample capture device.',
        EBTS: {
            mnemonic: 'T14_DMM',
            index: '14.030',
            dataType: 'A'
        },
        required: false
    },
    ImageDataT14: {
        label: 'Image data',
        minLength: 1,
        required: false,
        EBTS: {
            mnemonic: 'T14_DAT',
            index: '14.999',
            dataType: 'B1'
        }
    }
};
//# sourceMappingURL=jfd.type14.js.map